import React from "react";
import { EMPTY_STRING } from "../../../constants";

const ProfileImage = ({ imageUrl = EMPTY_STRING, alt = "PI" }) => {
  return (
    <div className="position-relative circle-wrapper">
      <img
        src={`${process.env.REACT_APP_S3_BASE_URL_PORTFOLIO}/${imageUrl}`}
        alt={alt}
        className="img-fluid rounded-circle profile-img"
      />
    </div>
  );
};

export default ProfileImage;
